
import { Vue } from "vue-class-component";

export default class ReadyToCargo extends Vue {}
